<template>
  <div id="app">
    <!-- 路由视图，用于显示当前页面组件 -->
    <router-view />

    <!-- 全屏加载效果 -->
    <div v-if="isLoading" class="global-loading-mask">
      <div class="loading-content">
        <div class="loading-spinner"></div>
        <div class="loading-text">
          设备识别成功，正在加载您的专属页面...<br />
          设备号：{{ currentDeviceId }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      isLoading: false, // 加载状态
      currentDeviceId: "", // 当前设备号
      isLoadingGuard: false, // 防止重复请求的标志（可选，用于额外控制）
    };
  },
  created() {
    // 对应原 onLaunch，在应用初始化时执行一次
    this.initApp();
  },
  mounted() {
    // 对应原 onShow 中的逻辑 + mounted 中的逻辑
    this.handleHashRedirect();

    // 监听路由变化，处理 hash 变化（如果页面不刷新）
    window.addEventListener("popstate", this.handleHashRedirect);
  },
  beforeDestroy() {
    // 对应原 onHide，清理监听器
    window.removeEventListener("popstate", this.handleHashRedirect);
  },
  methods: {
    // 应用初始化逻辑（原 onLaunch 内容）
    initApp() {},

    // 处理 URL hash 重定向（原 handleHashRedirect）
    handleHashRedirect() {
      // 防止重复处理，如果已经在加载中则直接返回
      if (this.isLoading) {
        console.log("已有加载任务进行中，跳过本次hash处理");
        return;
      }

      const hash = window.location.hash;
      if (!hash) return;

      // Vue Router 默认使用 #/ 形式，移除开头的 '#'
      const path = hash.startsWith("#/") ? hash.slice(1) : hash;
      const [routePath, queryStr] = path.split("?");
      const params = new URLSearchParams(queryStr || "");

      console.log(routePath, "?");

      let deviceId = null; // 设备号（sn或iccid）

      // 根据路由路径提取设备号
      if (routePath === "/qrcode") {
        deviceId = params.get("sn") || params.get("");
      } else if (routePath === "/qrcode/achangeInvent") {
        deviceId = params.get("iccid") || params.get("");
      } else {
        this.$router.push({ path: "/device-missing" });
        return; // 不是目标路径，不处理
      }

      // 判断设备号是否为空（null、undefined 或空字符串）
      if (!deviceId || deviceId.trim() === "") {
        console.warn("设备号为空，跳转到项目另一个页面");
        // 跳转到项目的另一个页面（请根据实际路由配置修改）
        // 示例：跳转到设备缺失页面或登录页
        this.$router.push({ path: "/device-missing" });
        return;
      }

      // 设备号非空，显示加载效果并开始处理
      this.currentDeviceId = deviceId;
      this.isLoading = true;

      // 调用接口查询跳转地址
      this.printingQuery(deviceId);
    },

    // 打印查询逻辑（原 printingQuery，增强版）
    printingQuery(deviceId) {
      const currentUrl = window.location.origin;
      this.$REQ(
        this.$api.printingQuery,
        { sn: deviceId, url: currentUrl },
        "get"
      )
        .then((res) => {
          if (res.data && res.data.url) {
            let redirectUrl = res.data.url;
            if (res.data.key) {
              redirectUrl += res.data.key;
            }
            // 先隐藏加载效果，再执行外部跳转
            this.isLoading = false;
            window.location.href = redirectUrl;
            return;
          } else {
            // 没有获取到跳转地址时执行降级
            console.warn("接口未返回跳转地址，执行降级跳转");
            this.isLoading = false;
            this.redirectWithParam("http://help.ha818.cn", { sn: deviceId });
          }
        })
        .catch((err) => {
          // 打印具体错误信息，便于定位
          console.error("打印接口失败，错误详情：", err);
          // 降级跳转前先隐藏加载效果
          this.isLoading = false;
          this.redirectWithParam("http://help.ha818.cn", { sn: deviceId });
        });
    },

    // 带参数跳转（原 redirectWithParam）
    redirectWithParam(pagePath, params) {
      // 将 params 对象转换为查询字符串
      const queryString = Object.keys(params)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
        )
        .join("&");

      // 如果 pagePath 已经包含 '?'，则需要用 '&' 拼接，否则用 '?' 拼接
      const separator = pagePath.includes("?") ? "&" : "?";
      const url = queryString
        ? `${pagePath}${separator}${queryString}`
        : pagePath;

      // 使用 window.location.href 跳转
      window.location.href = url;
    },

    // 清除 URL 中的 hash（原 clearHash）
    clearHash() {
      if (window.history.replaceState) {
        const newUrl = window.location.pathname + window.location.search;
        window.history.replaceState(null, "", newUrl);
        console.log("已清除 hash");
      }
    },
  },
};
</script>

<style scoped>
.wad {
  color: white;
}

/* 全屏加载遮罩层样式 */
.global-loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(4px);
}

.loading-content {
  text-align: center;
  color: #ffffff;
  padding: 20px;
  border-radius: 12px;
  background-color: rgba(0, 0, 0, 0.6);
  min-width: 280px;
}

/* 转圈加载动画 */
.loading-spinner {
  width: 50px;
  height: 50px;
  margin: 0 auto 20px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid #ffffff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  font-size: 16px;
  line-height: 1.5;
  word-break: break-all;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}
</style>